import { useReducer } from 'react';

// tags: forceupdate, forcerender, forcererender, forcerefresh
export default function useForceUpdate() {
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  return forceUpdate;
}
